<template>
  <authenticated-layout>
    <PageHeader title="Cohorts" />
    <cohort-data-table />
  </authenticated-layout>

</template>

<script setup lang="ts">

import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import CohortDataTable from "@/components/DataTables/CohortDataTable.vue";
import PageHeader from "@/components/PageHeader.vue";
</script>

<style scoped>

</style>
